import React, { useEffect, useState } from "react";
import Select from "react-select";
import { dealSummary } from "http/fundLync/deal.helper";
import { AiFillDelete } from 'react-icons/ai';
import {
    Card,
    Col,
    Row,
    Table,
    CardBody,
    Container,
    Button,
    UncontrolledTooltip
} from "reactstrap";
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import "./dealSummary.css";
import ToastDialog from "components/Common/ToastDialog";
import { dealStatusBucket, dealStatusBucketSummary, decryptedValue, formatNumberWithCommas, isPermission } from "common/utility";
import { conditionOptions, dealSummaryFIlters } from "common/utility";
import { HiFunnel } from "react-icons/hi2";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import { callGetCIUser, callReferredFinancier } from "http/fundLync/dealFinancier";
import { format, parse } from "date-fns";
import { callFinancierList, callfinListSummary } from "http/fundLync/common.helper";
import { useAsyncDebounce } from "react-table";
import * as XLSX from 'xlsx';

const DealSummary = () => {
    document.title = "Deal Summary | Fundlync";
    const [anchorRegions, setAnchorRegions] = useState({});
    const [distinctAnchors, setDistinctAnchors] = useState([]);
    const [dealsData, setDealsData] = useState([]);
    const [statusWiseData, setStatusWiseData] = useState([]);
    const [totalDealsSummary, setTotalDealsSummary] = useState({});
    const [totalDealsCount, setTotalDealsCount] = useState({});
    const [expandedRows, setExpandedRows] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [showDateFilter, setShowDateFilter] = useState(false);
    const navigate = useNavigate();
    const [dealColumnList, setDealColumnList] = useState(dealSummaryFIlters);
    const [filterApplied, setFilterApplied] = useState(false);
    const [hover, setHover] = useState(false);
    const [filterPopupVisible, setFilterPopupVisible] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [hoverTooltip, setHoverTooltip] = useState(false);
    const [proposalTypeList, setProposalTypeList] = useState([]);
    const [partnerProgramList,setPartnerProgramList] = useState([]);
    const [selectedProposalType, setSelectedProposalType] = useState([]);
    const [selectedPartnerProgram, setSelectedPartnerProgram] = useState([]);
    const [selectedFiltersView, setSelectedFiltersView] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState({ value: 'All', label: 'All' });
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedProgramManager, setSelectedProgramManager] = useState([]);
    const [selectedPMUser, setSelectedPMUser] = useState([]);
    const [selectedRMUser, setSelectedRMUser] = useState([]);
    const [referredFinanciersList, setReferredFinanciersList] = useState([])
    const [selectedReferredCompany, setSelectedReferredCompany] = useState([]);
    const [inputValueForReferredCompany, setInputValueForReferredCompany] = useState('');
    const [isDownloadPermission, setIsDownloadPermission] = useState(false)

    const [toastInfo, setToastInfo] = useState({
        message: "",
        showToast: false,
        role: "",
    });
    const checkPermissions = async () => {
        const isSDownloadpermission = await isPermission(
          "download_deal_summary_data", 
          "view_permission"
        );
        setIsDownloadPermission(isSDownloadpermission)
      };
    const filterStateSetters = {
        "Proposal Type": (filter) => setSelectedProposalType(filter),
        "Partner program":(filter) => setSelectedPartnerProgram(filter),
        "RM": (filter) => setSelectedRMUser(filter),
        "Program RM": (filter) => setSelectedPMUser(filter),
        "Financiers": (filter) => setSelectedReferredCompany(filter),
        
        "Closure Date": (filter) => {
          setStartDate(filter.startDate);
          setEndDate(filter.endDate);
        },
        "Deal Status" : (filter) => setSelectedStatus(filter),
      };
    useEffect(() => {
        const data = JSON.parse(localStorage.getItem("selectedFilters_deal_summary"))
        const storedRegion = JSON.parse(localStorage.getItem("selectedRegion_deal_summary")) || { value: 'All', label: 'All' };
        const regionFilters = Object.values(storedRegion);
        if (data?.length > 0 || storedRegion !== "") {
            if (data?.length > 0) {
                setFilterApplied(true);
                setSelectedFilters(data);
                setSelectedFiltersView(data);
                data.forEach((filter) => {
                    setDealColumnList(prevList =>
                        prevList.filter(item => item.value !== filter.value)
                    );
                    const setFilterState = filterStateSetters[filter.label];

                    if (setFilterState && filter.label !== "Closure Date" && filter.label !== "Created Date") {
                        setFilterState({ label: filter.filterDisplay, value: filter.filterValue });
                    } if (setFilterState && filter.label === "Closure Date") {
                        setFilterState(filter.filterValue);
                    } if (setFilterState && filter.label === "Created Date") {
                        setFilterState(filter.filterValue);
                    } if (setFilterState && filter.label === "MoU signed" || filter.label === "Mandate signed") {
                        setFilterState({ label: filter.filterValue, value: filter.filterValue });
                    }
                });
            }
            setSelectedRegion(storedRegion)

            dealSummary({ filter: data || [], regionFilter: regionFilters.length ? regionFilters[0] : 'All' })
                .then(response => {
                    if (response.status) {
                        const data = response.data.dealsSummary;
                        const statusWiseData = response.data.statusWiseSummaryByAnchor;
                        const totalSummary = response.data.totalDealsSummary;
                        const totalCount = response.data.totalCount;
                        const uniqueAnchors = Array.from(
                            new Set(data.map(item => item.anchor?.entityName))
                        ).map(anchorName => {
                            const anchor = data.find(item => item.anchor?.entityName === anchorName).anchor;
                            return {
                                anchorName,
                                id: anchor ? anchor.id : "-",
                                region: regionFilters.length ? regionFilters[0] : 'All',
                            };
                        });

                        const initialAnchorRegions = uniqueAnchors.reduce((acc, anchor) => {
                            acc[anchor.anchorName] = regionFilters.length ? regionFilters[0] : 'All';
                            return acc;
                        }, {});
                        setDistinctAnchors(uniqueAnchors);
                        setDealsData(data);
                        setAnchorRegions(initialAnchorRegions);
                        setStatusWiseData(statusWiseData);
                        setTotalDealsSummary(totalSummary);
                        setTotalDealsCount(totalCount)
                        setShowDateFilter(false);
                    } else {
                        setDistinctAnchors([]);
                        setDealsData([]);
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }

        else if (selectedFilters.length === 0) {
            getData();
        } else {
            getData();
        }

    }, []);

    const fetchDealSummary = (filters = [], regionFilter = 'All') => {
        dealSummary({
            filter: filters,
            regionFilter: regionFilter
        })
        .then(response => {
            if (response.status) {
                const data = response.data.dealsSummary;
                const statusWiseData = response.data.statusWiseSummaryByAnchor;
                const totalSummary = response.data.totalDealsSummary;
                const totalCount = response.data.totalCount;
                const uniqueAnchors = Array.from(
                    new Set(data.map(item => item.anchor?.entityName))
                ).map(anchorName => {
                    const anchor = data.find(item => item.anchor?.entityName === anchorName).anchor;
                    return {
                        anchorName,
                        id: anchor ? anchor.id : "-",
                    };
                });
    
                const initialAnchorRegions = uniqueAnchors.reduce((acc, anchor) => {
                    acc[anchor.anchorName] = 'All';
                    return acc;
                }, {});
    
                setDistinctAnchors(uniqueAnchors);
                setDealsData(data);
                setAnchorRegions(initialAnchorRegions);
                setStatusWiseData(statusWiseData);
                setTotalDealsSummary(totalSummary);
                setTotalDealsCount(totalCount);
                setShowDateFilter(false);
            } else {
                setDistinctAnchors([]);
                setDealsData([]);
            }
        })
        .catch(error => {
            console.error("Error fetching data:", error);
        });
    };
    
    
    const toggleFilterPopup = () => {
        setFilterPopupVisible(!filterPopupVisible);
    };
    const toggleRowExpansion = (anchorName) => {
        if (expandedRows.includes(anchorName)) {
            setExpandedRows(expandedRows.filter(row => row !== anchorName));
        } else {
            setExpandedRows([...expandedRows, anchorName]);
        }
    };
    const anchorValues = useAsyncDebounce((value) => {
        loadFinancierList(value); 
      }, 500);
      
      const loadFinancierList = (search) => {
        callfinListSummary({ limit: 10, searchKey: search }) 
          .then(entityResponseForDeal => {
            setReferredFinanciersList(Array.isArray(entityResponseForDeal?.data) ? entityResponseForDeal.data : []);
          })
          .catch(error => {
            setReferredFinanciersList([]);
          });
      };
    const getDropDownForDeals = async () => {
        try {
            callfinListSummary({ limit: 10 }) 
          .then(entityResponseForDeal => {
            setReferredFinanciersList(Array.isArray(entityResponseForDeal?.data) ? entityResponseForDeal.data : []);
          })
          .catch(error => {
            setReferredFinanciersList([]);
          });

            const rmUsersResponse = await callGetCIUser();
            setSelectedProgramManager(rmUsersResponse?.data?.rows)


            if (proposalTypeList.length == 0) {
                const prospectives = await getDropDownList({ dropdownName: "Proposal Type" });
                const prospectiveValues = prospectives.data?.rows?.find(dv => dv.dropdownName === "Proposal Type")?.dropdownValues || [];
                setProposalTypeList(prospectiveValues);
            }
              if (partnerProgramList.length == 0) {
                const partnerProgram = await getDropDownList({ dropdownName: "Partner program" });
                const partnerProgramValues = partnerProgram.data?.rows?.find(dv => dv.dropdownName === "Partner program")?.dropdownValues || [];
                setPartnerProgramList(partnerProgramValues);
            } 
        } catch (error) {
            console.error(error);
        }
    }

    const handleGlobalRegionChange = (selectedRegion) => {
        setSelectedRegion(selectedRegion);
        const updatedRegions = distinctAnchors.reduce((acc, anchor) => {
            acc[anchor.anchorName] = selectedRegion.value;
            return acc;
        }, {});
        const region = selectedRegion || "All";
        localStorage.setItem("selectedRegion_deal_summary", JSON.stringify(region));

        setAnchorRegions(updatedRegions);
        dealSummary({ filter: selectedFilters, regionFilter: selectedRegion.value })
            .then(response => {
                if (response.status) {
                    const data = response.data.dealsSummary;
                    const statusWiseData = response.data.statusWiseSummaryByAnchor;
                    const totalSummary = response.data.totalDealsSummary;
                    const totalCount = response.data.totalCount;
                    const uniqueAnchors = Array.from(
                        new Set(data.map(item => item.anchor?.entityName))
                    ).map(anchorName => {
                        const anchor = data.find(item => item.anchor?.entityName === anchorName).anchor;
                        return {
                            anchorName,
                            id: anchor ? anchor.id : "-",
                            region: selectedRegion.value ? selectedRegion.value : 'All',
                        };
                    });

                    const initialAnchorRegions = uniqueAnchors.reduce((acc, anchor) => {
                        acc[anchor.anchorName] = selectedRegion.value ? selectedRegion.value : 'All';
                        return acc;
                    }, {});

                    setDistinctAnchors(uniqueAnchors);
                    setDealsData(data);
                    setAnchorRegions(initialAnchorRegions);
                    setStatusWiseData(statusWiseData);
                    setTotalDealsSummary(totalSummary);
                    setTotalDealsCount(totalCount)
                    setShowDateFilter(false);
                } else {
                    setDistinctAnchors([]);
                    setDealsData([]);
                }
            })
            .catch(error => {
                console.error(error);
            });
    };

    useEffect(() => {
        checkPermissions()
        if (currentIndex !== null) {
            handleDateChangeClosure(currentIndex);
        }
    }, [startDate, endDate, currentIndex]);
    const handleDateChangeClosure = (index) => {
        handleFilterValueChange(index, { startDate: startDate, endDate: endDate });
    }
    const handleClearFilters = () => {
        setSelectedFilters([]);
        setSelectedFiltersView([]);
        setDealColumnList(dealSummaryFIlters);
        setEndDate('');
        setStartDate('');
        setSelectedProposalType([]);
        setSelectedPartnerProgram([]);
        setSelectedRMUser([]);
        setSelectedPMUser([]);
        setSelectedStatus([])
        setSelectedReferredCompany([]);
        setSelectedRegion({ value: 'All', label: 'All' });
        setShowDateFilter(false);
        setFilterApplied(false);
    
        const tableKey = "selectedFilters_deal_summary";
        localStorage.removeItem(tableKey);
        localStorage.removeItem("selectedRegion_deal_summary");
        fetchDealSummary();
    };
    

    const getData = () => {
        const regionFilters = Object.values(anchorRegions);
        dealSummary({ filter: selectedFilters, regionFilter: regionFilters.length ? regionFilters[0] : 'All' })
            .then(response => {
                if (response.status) {
                    const data = response.data.dealsSummary;
                    const statusWiseData = response.data.statusWiseSummaryByAnchor;
                    const totalSummary = response.data.totalDealsSummary;
                    const totalCount = response.data.totalCount;
                    const uniqueAnchors = Array.from(
                        new Set(data.map(item => item.anchor?.entityName))
                    ).map(anchorName => {
                        const anchor = data.find(item => item.anchor?.entityName === anchorName).anchor;
                        return {
                            anchorName,
                            id: anchor ? anchor.id : "-",
                            region: regionFilters.length ? regionFilters[0] : 'All',
                        };
                    });

                    const initialAnchorRegions = uniqueAnchors.reduce((acc, anchor) => {
                        acc[anchor.anchorName] = regionFilters.length ? regionFilters[0] : 'All';
                        return acc;
                    }, {});

                    setDistinctAnchors(uniqueAnchors);
                    setDealsData(data);
                    setAnchorRegions(initialAnchorRegions);
                    setStatusWiseData(statusWiseData);
                    setTotalDealsSummary(totalSummary);
                    setTotalDealsCount(totalCount)
                    setShowDateFilter(false);
                } else {
                    setDistinctAnchors([]);
                    setDealsData([]);
                }
            })
            .catch(error => {
                console.error(error);
            });

    };
    const handleFilterValueChange = (index, value, display) => {
        const newFilters = selectedFilters.map((filter, i) =>
            i === index ? { ...filter, filterValue: value, filterDisplay: display } : filter
        );
        setSelectedFilters(newFilters);
    };
    const saveFiltersToLocalStorage = (filters) => {
        const tableKey = "selectedFilters_deal_summary";
        localStorage.setItem(tableKey, JSON.stringify(filters));
      };

    const handleSelectChange = (selectedOption) => {
        const newFilter = {
            label: selectedOption.label,
            value: selectedOption.value,
            condition: conditionOptions[0].value,
            filterValue: "",
        };
        setSelectedFilters([...selectedFilters, newFilter]);
        setDealColumnList(prevList =>
            prevList.filter(item => item.value !== selectedOption.value)
        );
    };
    const handleConditionChange = (index, condition) => {
        const newFilters = selectedFilters.map((filter, i) =>
            i === index ? { ...filter, condition: condition.value } : filter
        );
        setSelectedFilters(newFilters);
    };
    const handleApplyFilters = () => {
        if (hasValidFilterValues(selectedFilters)) {
            getData()
            setSelectedFiltersView(selectedFilters)
            setFilterPopupVisible(false)
            setFilterApplied(true)
            saveFiltersToLocalStorage(selectedFilters);
        } else {
            setToastInfo({
                message: "Selected Field Empty in Filter",
                showToast: true,
                role: "error",
            });
        }
    };
    const handleApplyFilters1 = () => {
        const errors = hasValidFilterValues(selectedFilters);

        if (!errors) {

        } else {
            const errorMessage = `Please provide a value for ${errors.join(' and ')}.`;
            setToastInfo({
                message: errorMessage,
                showToast: true,
                role: "error",
            });
        }
    };

    const hasValidFilterValues = (filters) => {
        return filters.every(filter => {
            const value = filter.filterValue;
            if (filter.label === "Closure Date") {

                const { startDate, endDate } = filter.filterValue || {};
                return (startDate && startDate !== "") || (endDate && endDate !== "");


            }

            // General check for other filters
            return !(value === "" || (Array.isArray(value) && value.length === 0));
        });
    };


    const getFilteredDataForAnchor = (anchorName) => {

        const selectedRegion = (anchorRegions[anchorName] || 'All').toLowerCase();

        return dealsData.filter((item) => {
            const itemAnchor = (item.anchor?.entityName || '').toLowerCase();
            const itemRegion = (item.counterparty?.region || '').toLowerCase();

            const isAnchorMatch = itemAnchor === anchorName?.toLowerCase();
            // const isRegionMatch = selectedRegion === 'all' || itemRegion === selectedRegion;

            return isAnchorMatch ;
        });
    };

    const getStatusWiseDataForAnchor = (anchorName) => {
        const selectedRegion = (anchorRegions[anchorName] || 'All').toLowerCase();

        // Filter based on anchor and region
        const filteredData = statusWiseData.filter((item) => {
            const itemAnchor = (item.anchor?.entityName || '').toLowerCase();

            const isAnchorMatch = itemAnchor === anchorName.toLowerCase();

            return isAnchorMatch;
        });
        return filteredData;
    };

    const user = decryptedValue(localStorage.getItem("user"));
    const navigateToEditEntity = (entityId) => {
        if (entityId) {
            const encryptedId = btoa(entityId.toString());
            const url = `/${user.roleName}/entity-Dashboard?id=${encodeURIComponent(encryptedId)}`;
            return url;
        }
    };

    const handleMouseEnter = (event) => {
        event.target.style.color = "#34c38f";
        event.target.style.textDecoration = 'underline';
    };

    const handleMouseLeave = (event) => {
        event.target.style.color = "#21aa47";
        event.target.style.textDecoration = 'none';
    };

    const redirectToDealList = (dealIds) => {
        const dealIdsParam = btoa(dealIds.toString());
        navigate(`/${user.roleName}/listDeal?dealIDs=${encodeURIComponent(dealIdsParam)}`);
        
    };

    const formatAmount = (amount) => {
        if (typeof amount === 'number' || (typeof amount === 'string' && !isNaN(amount))) {
            const numericAmount = Number(amount);
            return `₹ ${numericAmount.toLocaleString('en-IN')}`;
        }
        return amount;
    };

    const statusMapping = {
        "1": 'Financier Queue',
        "2": 'Submitted By Partner',
        "3": 'Draft',
        "4": 'Submitted By Customer',
        "5": 'Pending E-Signing',
        "6": 'Prospect',
        "7": 'Meeting Done',
        "8": 'WIP',
        "9": 'Referred',
        "10": 'Queries',
        "11": 'Approved',
        "12": 'Rejected',
        "13": 'On Hold',
        "14": 'Pre Sanction Documents',
        "15": 'Live',
        "16": 'Customer backed out',
        "17": 'Terms conditions not accepted',
        '18': 'Deal lost',
        "19": 'Sanctioned',
        "20": 'Credit Appraisal',
        "21": 'GST Karza Completed',
        "22": 'PD Done',
    };

    const calculateTotalByRegion = () => {
        let totalCases = 0;
        let totalAmount = 0;
        let syndicationAmount = 0;
        let integrationAmount = 0;
        let dealIds = [];

        distinctAnchors.forEach(anchor => {
            const filteredData = getFilteredDataForAnchor(anchor.anchorName);
            totalCases = totalDealsCount[0].dealCount;
            totalAmount = totalDealsSummary[0].totalAmount;
            syndicationAmount = totalDealsSummary[0].totalSyndicationFees;
            integrationAmount = totalDealsSummary[0].totalIntegrationFees;
            dealIds = dealIds.concat(filteredData.flatMap(item => item.dealIds));
        });
        return { totalCases, totalAmount, syndicationAmount, integrationAmount, dealIds };
    };

    const totalByRegion = calculateTotalByRegion();
    const getButtonColor = () => {
        if (filterPopupVisible) {
            return 'success'; 
        }
        if (filterApplied) {
            return '#007bac';
        }
        return 'light'; 
    };

    const handleDeleteFilter = (label) => {
        switch (label) {
            case 'Deal Status':
                setSelectedStatus([]);
                break
            case 'Proposal Type':
                setSelectedProposalType([]);
                break;
            case 'Partner program':
                setSelectedPartnerProgram([]);
                break;   
            case 'Closure Date':
                setEndDate('');
                setStartDate('')
                break;
            case 'RM':
                setSelectedRMUser([]);
                break;
            case 'Program RM':
                setSelectedPMUser([]);
                break;
            case 'Financiers':
                setSelectedReferredCompany([]);
                break;
            default:
                break;
        }
    };

    const handleClearFilter = (index) => {
        const removedFilter = selectedFilters[index];
        setSelectedFilters(prevFilters => prevFilters.filter((_, i) => i !== index));
        const insertIndex = dealSummaryFIlters.findIndex(item => item.value === removedFilter.value);
        handleDeleteFilter(removedFilter.label)
        setDealColumnList(prevList => [
            ...prevList.slice(0, insertIndex),
            { label: removedFilter.label, value: removedFilter.value },
            ...prevList.slice(insertIndex)
        ]);
        getData()
    };
    const formatCondition = (condition) => {
        return condition
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };
    const formatExpectedClosureDate = (dateString) => {
        if (!dateString) return '';
        const date = parse(dateString, 'yyyy-MM', new Date());
        return format(date, 'MMMM, yyyy');
      };

      const createAndDownloadExcel = async (fileName, deals) => {
        if (deals.length === 0) {
            setToastInfo({
                message: "No deals available for download.",
                showToast: true,
                role: "warning",
            });
            return;
        }
        deals.sort((a, b) => (a.anchor?.entityName || "").localeCompare(b.anchor?.entityName || ""));
        let newData = deals.map((ele) => {
            return {
                'Anchor Name': ele.anchor?.entityName || "",
                'Region': ele.counterparty?.region || "",
                'Counterparty Name': ele.counterparty?.entityName || "",
                'Total Loan Amount': ele.totalAmount ? formatAmount(ele.totalAmount) : "0",
                'Gross PF': ele.totalSyndicationFees ? formatAmount(ele.totalSyndicationFees) : "0",
                'Net PF': ele.totalIntegrationFees ? formatAmount(ele.totalIntegrationFees) : "0",
            };
        });
    
        const ws = XLSX.utils.json_to_sheet(newData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Deals');
        const buffer = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'array' });
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.download = `${fileName}.xlsx`;
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setToastInfo({
            message: "File downloaded successfully.",
            showToast: true,
            role: "success",
          });
    };

      const handleDownloadData = () => {
        const fileName = "Deal_Summary";
        createAndDownloadExcel(fileName,dealsData);
    };
    

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs title="DEAL SUMMARY" />
                <Row className="vertical-scroll">
                    <Col xs="12">
                        <Card>
                            <CardBody>
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                    <div className="d-flex align-items-center mb-3 ">
                                        <div className="d-flex align-items-center">
                                            <span>Region: </span>
                                            <Select
                                                options={[
                                                    { value: 'All', label: 'All' },
                                                    { value: 'East', label: 'East' },
                                                    { value: 'West', label: 'West' },
                                                    { value: 'North', label: 'North' },
                                                    { value: 'South', label: 'South' },
                                                ]}
                                                value={selectedRegion}
                                                onChange={(selectedOption) => handleGlobalRegionChange(selectedOption)}
                                                className="ms-2"
                                                isClearable={false}
                                                isSearchable={false}
                                            />
                                        </div>
                                        <div className="mt-2 " style={{ paddingLeft: '10px' }}>
                                            <Button
                                                type="button"
                                                color={filterApplied ? undefined : getButtonColor()}
                                                style={filterApplied ? { backgroundColor: getButtonColor(), borderColor: getButtonColor() } : {}}
                                                className="mb-2 me-2"
                                                onClick={() => {
                                                    toggleFilterPopup()
                                                    getDropDownForDeals()
                                                }}
                                                onMouseEnter={() => setHover(true)} // Display tooltip on hover
                                                onMouseLeave={() => setHover(false)}
                                            >
                                                <HiFunnel style={{ fontSize: '1rem' }} />
                                            </Button>
                                            <Button
                                                type="button"
                                                color="light"
                                                className="btn-rounded mb-2 me-2 ms-2 border-success"
                                                onClick={(e) => {
                                                    // handleClearSearch(e),
                                                    handleClearFilters(e)
                                                }}
                                            >
                                                Clear
                                            </Button>
                                        </div>


                                    </div>{isDownloadPermission && (
                                        <>
                                            <div className="d-flex justify-content-end mb-12">
                                                <Button
                                                    id="downloadTooltip"
                                                    type="button"
                                                    color="light"
                                                    className="btn-rounded mb-2 me-2 ms-2 border-success"
                                                    onClick={() => {
                                                        handleDownloadData();
                                                    }}
                                                >
                                                    <i className="fa fa-download"></i>
                                                </Button>
                                                <UncontrolledTooltip placement="top" target="downloadTooltip">
                                                    Download Deal Summary
                                                </UncontrolledTooltip>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <>
                                    {(hover || hoverTooltip) && selectedFiltersView.length > 0 && (
                                        <div
                                            className="tooltip-content"
                                            style={{
                                                position: 'absolute',
                                                top: '64px',
                                                right: '1',
                                                background: '#dcdce4',
                                                zIndex: 1000,
                                                padding: '10px',
                                                borderRadius: '5px',
                                                maxWidth: '400px',
                                                width: '100%',
                                                textAlign: 'left',
                                                maxHeight: '200px',
                                                overflowY: 'auto',
                                                boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
                                                scrollbarWidth: 'thin'
                                            }}
                                            onMouseEnter={() => setHoverTooltip(true)}
                                            onMouseLeave={() => setHoverTooltip(false)}
                                        >
                                            <h6>Applied Filters:</h6>
                                            <ul style={{ listStyleType: 'disc', padding: '10px' }}>
                                                {selectedFiltersView?.map((filter, index) => {
                                                    return (<li key={index} style={{ marginBottom: '5px' }}>

                                                        <span style={{ color: '#22aa48' }}>
                                                            {filter.label} -
                                                        </span>{' '}
                                                        <span style={{ color: '#7e7c7d' }}>
                                                            {formatCondition(filter.condition)}:
                                                        </span>{' '}
                                                        <span style={{ color: '#2980b9' }}>
                                                            {filter.label === "Deal Name" || filter.label === "MoU signed" || filter.label === "Mandate signed"
                                                                ? filter.filterValue
                                                                : filter.label === "Created Date"
                                                                    ? `${formatDateString(filter.filterValue[0]) || 'N/A'} to ${formatDateString(filter.filterValue[1]) || 'N/A'}`
                                                                    : filter.label === "Closure Date"
                                                                        ? `${formatExpectedClosureDate(filter.filterValue.startDate) || 'N/A'} to ${formatExpectedClosureDate(filter.filterValue.endDate) || 'N/A'}`
                                                                        : filter.filterDisplay?.join(', ') || 'N/A'}
                                                        </span>
                                                    </li>)
                                                })}
                                            </ul>
                                        </div>
                                    )}

                                    <Col sm="1" className="ms-2 me-2">
                                        {filterPopupVisible && (
                                            <div
                                                className="filter-popup display-flex justify-content-end"
                                                style={{
                                                    position: 'absolute',
                                                    top: '4rem',
                                                    right: '1',
                                                    background: 'white',
                                                    boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
                                                    zIndex: 1000,
                                                    padding: '10px',
                                                    borderRadius: '5px',
                                                    minHeight: '350px',
                                                    maxHeight: '400px',
                                                    overflow: 'auto',
                                                    scrollbarWidth: 'thin',
                                                    maxWidth: '300px',
                                                    width: '100%',
                                                }}
                                            >
                                                <div className="mb-1 d-flex justify-content-between align-items-center text-center">
                                                    <h5 style={{ margin: 0 }}>Filter Deals By</h5>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            setFilterPopupVisible(false)
                                                            //   handleClearFilters(e)
                                                            // handleClearSearch(e)
                                                        }}
                                                        style={{
                                                            border: 'none',
                                                            background: 'transparent',
                                                            fontSize: '1.2rem',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        ×
                                                    </button>
                                                </div>

                                                <div
                                                    className="mb-3"
                                                    style={{
                                                        scrollbarWidth: 'thin',
                                                        scrollbarColor: 'rgba(0,0,0,0.1) rgba(0,0,0,0.05)',
                                                        padding: '0px 5px',
                                                    }}
                                                >
                                                    <Select
                                                        options={dealColumnList.map((option) => ({
                                                            label: option.label,
                                                            value: option.value,
                                                        }))}
                                                        placeholder="Enter Filter"
                                                        value={""}
                                                        onChange={handleSelectChange}
                                                    />
                                                </div>

                                                <div className="selected-filters" style={{ minHeight: '230px' }}>
                                                    {selectedFilters.map((filter, index) => (
                                                        <div
                                                            key={index}
                                                            className="selected-filter mb-3"
                                                            style={{
                                                                padding: '5px 0px',
                                                                backgroundColor: index % 2 === 0 ? 'rgb(244, 244, 244)' : 'white',
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    padding: '0rem 0.5rem',
                                                                }}
                                                            >
                                                                {filter.label}
                                                                <AiFillDelete
                                                                    className="delete-icon"
                                                                    onClick={() => {
                                                                        handleClearFilter(index)
                                                                    }}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        color: 'rgb(167, 167, 167)',
                                                                    }}
                                                                />
                                                            </label>
                                                            <div style={{ padding: '0px 5px' }}>
                                                                {filter.label === "Proposal Type" && (
                                                                    <Select
                                                                        className="mt-2"
                                                                        isMulti
                                                                        options={proposalTypeList.map((option) => ({
                                                                            label: `${option.displayName}`,
                                                                            value: option.dropdownValue,
                                                                        }))}
                                                                        value={selectedProposalType}
                                                                        onChange={(selectedOptions) => {
                                                                            setSelectedProposalType(selectedOptions);
                                                                            handleFilterValueChange(
                                                                                index,
                                                                                selectedOptions.map((option) => option.value),
                                                                                selectedOptions.map((option) => option.label)
                                                                            );
                                                                        }}
                                                                    />
                                                                )}
                                                                {filter.label === "Partner Program" && (
                                                                    <Select
                                                                        className="mt-2"
                                                                        isMulti
                                                                        options={partnerProgramList.map((option) => ({
                                                                            label: `${option.displayName}`,
                                                                            value: option.dropdownValue,
                                                                        }))}
                                                                        value={selectedPartnerProgram}
                                                                        onChange={(selectedOptions) => {
                                                                            setSelectedPartnerProgram(selectedOptions);
                                                                            handleFilterValueChange(
                                                                                index,
                                                                                selectedOptions.map((option) => option.value),
                                                                                selectedOptions.map((option) => option.label)
                                                                            );
                                                                        }}
                                                                    />
                                                                )}

                                                                {filter.label === "RM" && (
                                                                <Select
                                                                    className="mt-2"
                                                                    isMulti
                                                                    options={selectedProgramManager.map((option) => ({
                                                                    label: `${option.firstName + " " + option.lastName}`,
                                                                    value: option.id,
                                                                    }))}
                                                                    value={selectedRMUser}
                                                                    onChange={(selectedOptions) => {
                                                                        setSelectedRMUser(selectedOptions);
                                                                    handleFilterValueChange(
                                                                        index,
                                                                        selectedOptions.map((option) => option.value),
                                                                        selectedOptions.map((option) => option.label)
                                                                    );
                                                                    }}
                                                                />
                                                                )}
                                                                {filter.label === "Program RM" && (
                                                                <Select
                                                                    className="mt-2"
                                                                    isMulti
                                                                    options={selectedProgramManager.map((option) => ({
                                                                    label: `${option.firstName + " " + option.lastName}`,
                                                                    value: option.id,
                                                                    }))}
                                                                    value={selectedPMUser}
                                                                    onChange={(selectedOptions) => {
                                                                    setSelectedPMUser(selectedOptions);
                                                                    handleFilterValueChange(
                                                                        index,
                                                                        selectedOptions.map((option) => option.value),
                                                                        selectedOptions.map((option) => option.label)
                                                                    );
                                                                    }}
                                                                />
                                                                )}

                                                                {filter.label === "Financiers" && (
                                                                    <Select
                                                                    className="mt-2"
                                                                    isMulti
                                                                    options={Array.isArray(referredFinanciersList) && referredFinanciersList.length > 0
                                                                        ? referredFinanciersList
                                                                        .map(option => ({
                                                                            label: option.entityName,
                                                                            value: option.id,
                                                                        }))
                                                                        : []
                                                                    }
                                                                    placeholder="Type Financier Name"
                                                                    value={selectedReferredCompany}
                                                                    onInputChange={(value) => {
                                                                        setInputValueForReferredCompany(value);
                                                                        // if (value.length >= 2) {
                                                                        anchorValues(value); // Trigger debounced search when input has at least 2 characters
                                                                        // }
                                                                    }}
                                                                    //   menuIsOpen={inputValueForReferredCompany.length >= 2}
                                                                    onChange={(selectedOptions) => {
                                                                        setSelectedReferredCompany(selectedOptions);
                                                                        handleFilterValueChange(
                                                                        index,
                                                                        selectedOptions.map((option) => option.value),
                                                                        selectedOptions.map((option) => option.label)
                                                                        );
                                                                    }}
                                                                    />
                                                                )}

                                                                {filter.label === "Deal Status" && (
                                                                    <>
                                                                        <Select
                                                                            className="mt-2"
                                                                            isMulti
                                                                            options={dealStatusBucketSummary.map((option) => ({
                                                                                label: option.displayName,
                                                                                value: option.id,
                                                                            }))}
                                                                            value={selectedStatus}
                                                                            onChange={(selectedOptions) => {
                                                                                setSelectedStatus(selectedOptions);
                                                                                handleFilterValueChange(
                                                                                    index,
                                                                                    selectedOptions.map((option) => option.value),
                                                                                    selectedOptions.map((option) => option.label)
                                                                                );
                                                                            }}
                                                                        />
                                                                    </>
                                                                )}

                                                                {filter.label === "Closure Date" && (
                                                                    <div className="d-flex flex-column gap-2">
                                                                        <div className="d-flex flex-row align-items-center">
                                                                            <label htmlFor="startDate" className="me-2">Start Date:</label>
                                                                            <input
                                                                                type="month"
                                                                                value={startDate || ""}
                                                                                onChange={(e) => {
                                                                                    setStartDate(e.target.value);
                                                                                    setCurrentIndex(index);
                                                                                }}
                                                                                className={`form-control`}
                                                                                id="startDate"
                                                                                placeholder="MM/YYYY"
                                                                            />
                                                                        </div>
                                                                        <div className="d-flex flex-row align-items-center">
                                                                            <label htmlFor="endDate" className="me-2">End Date:</label>
                                                                            <input
                                                                                type="month"
                                                                                value={endDate || ""}
                                                                                onChange={(e) => {
                                                                                    setEndDate(e.target.value)
                                                                                    setCurrentIndex(index)
                                                                                }}
                                                                                className={`form-control`}
                                                                                id="endDate"
                                                                                placeholder="MM/YYYY"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}

                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div style={{ textAlign: 'end', marginTop: '10px' }}>
                                                    <Button
                                                        type="button"
                                                        color="light"
                                                        className="btn-rounded mb-2 me-2 border-success"
                                                        onClick={(e) => {
                                                            handleClearFilters(e)
                                                        }}
                                                    >
                                                        Clear All
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        color="success"
                                                        className="btn-rounded mb-2"
                                                        onClick={handleApplyFilters}
                                                    >
                                                        Apply
                                                    </Button>
                                                </div>
                                            </div>
                                        )}
                                    </Col>
                                </>
                                <div className="table-responsive">
                                    <Table className="table table-bordered mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>ID</th>
                                                <th>Anchor Name</th>
                                                <th>Region</th>
                                                <th>Total Cases</th>
                                                <th>Total Loan Amount</th>
                                                <th>Gross PF</th>
                                                <th>Net PF</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {distinctAnchors?.length > 0 ? (
                                                distinctAnchors.map((anchor, index) => {
                                                    const anchorName = anchor.anchorName || "-";
                                                    const filteredData = getFilteredDataForAnchor(anchorName);
                                                    const statusesToExclude = [12, 16, 17, 18];
                                                    const filteredDataForCalculation = filteredData.filter(item => !statusesToExclude.includes(Number(item.deal_status)));

                                                   const totalCases = filteredData.reduce((acc, item) => acc + (Number(item.dealCount) || 0), 0);
                                                    const dealIds = filteredData.flatMap(item => item.dealIds);
                                                    const totalAmount = filteredDataForCalculation.reduce((acc, item) => acc + (Number(item.totalAmount) || 0), 0);
                                                    const syndicationAmount = filteredDataForCalculation.reduce((acc, item) => acc + (Number(item.totalSyndicationFees) || 0), 0);
                                                    const integrationAmount = filteredDataForCalculation.reduce((acc, item) => acc + (Number(item.totalIntegrationFees) || 0), 0);
                                                    
                                                    const isExpanded = expandedRows.includes(anchorName);
                                                    const statusWiseDataForAnchor = getStatusWiseDataForAnchor(anchorName);

                                                    const rowClass = index % 2 === 0 ? 'bg-light' : 'bg-white';

                                                    return totalCases > 0 ? (
                                                        <React.Fragment key={anchorName}>
                                                            <tr className={rowClass}>
                                                                <td>{index + 1}</td>
                                                                <td onClick={() => toggleRowExpansion(anchorName)}>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <div className="font-size-18 text-success" style={{ marginRight: '10px' }}>
                                                                            <i className={`bx bxs-${isExpanded ? 'minus' : 'plus'}-circle`}></i>
                                                                        </div>
                                                                        <a
                                                                            href={navigateToEditEntity(anchor.id)}
                                                                            onMouseEnter={handleMouseEnter}
                                                                            onMouseLeave={handleMouseLeave}
                                                                            style={{ cursor: 'pointer', color: '#21aa47', textDecoration: 'none' }}
                                                                            title={anchorName || ''}
                                                                        >
                                                                            {anchorName}
                                                                        </a>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <span>{anchorRegions[anchorName]}</span>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="#"
                                                                        onClick={() => redirectToDealList(dealIds)}
                                                                        style={{ cursor: 'pointer', color: '#21aa47', width: '170px', textDecoration: 'none' }}
                                                                    >
                                                                        {totalCases}
                                                                    </a>
                                                                </td>
                                                                <td className="right-align">{totalAmount > 0 ? formatAmount(totalAmount) : '0'}</td>
                                                                <td className="right-align">{syndicationAmount > 0 ? formatAmount(syndicationAmount) : '0'}</td>
                                                                <td className="right-align">{integrationAmount > 0 ? formatAmount(integrationAmount) : '0'}</td>
                                                            </tr>
                                                            {isExpanded && statusWiseDataForAnchor.map((statusItem, idx) => {
    
                                                            const rowClassName = [12, 16, 17, 18].includes(Number(statusItem.deal_status)) ? "red-row" : "";
                                                            const textClassName = rowClassName ? "red-text" : "";

                                                            return (
                                                                <tr key={idx} className={rowClassName}>
                                                                    <td></td>
                                                                    <td className={textClassName}>
                                                                        {statusMapping[statusItem.deal_status] || statusItem.deal_status}
                                                                    </td>
                                                                    <td></td>
                                                                    <td>
                                                                        <a
                                                                            href="#"
                                                                            onClick={() => redirectToDealList(statusItem.dealIds)}
                                                                            style={{ cursor: 'pointer', color: '#21aa47', width: '170px', textDecoration: 'none' }}
                                                                            className={textClassName}
                                                                        >
                                                                            {statusItem.dealCount}
                                                                        </a>
                                                                    </td>
                                                                    <td className={`right-align ${textClassName}`}>{formatAmount(statusItem.totalAmount)}</td>
                                                                    <td className={`right-align ${textClassName}`}>{formatAmount(statusItem.totalSyndicationFees)}</td>
                                                                    <td className={`right-align ${textClassName}`}>{formatAmount(statusItem.totalIntegrationFees)}</td>
                                                                </tr>
                                                            );
                                                        })}

                                                        </React.Fragment>
                                                    ) : null;
                                                })
                                            ) : (
                                                // <tr>
                                                //     <td colSpan="8" className="text-center">No data available</td>
                                                // </tr>
                                                null
                                            )}
                                            {distinctAnchors?.length > 0 && totalByRegion.totalCases > 0 ? (
                                                <tr className="table-light">
                                                    <td colSpan="3">Total</td>
                                                    <td>
                                                        <a
                                                            href="#"
                                                            onClick={() => redirectToDealList(totalByRegion.dealIds)}
                                                            style={{ cursor: 'pointer', color: '#21aa47', width: '170px', textDecoration: 'none' }}
                                                        >
                                                            {totalByRegion.totalCases}
                                                        </a>
                                                    </td>
                                                    <td className="right-align">{totalByRegion.totalAmount > 0 ? formatAmount(totalByRegion.totalAmount) : '0'}</td>
                                                    <td className="right-align">{totalByRegion.syndicationAmount > 0 ? formatAmount(totalByRegion.syndicationAmount) : '0'}</td>
                                                    <td className="right-align">{totalByRegion.integrationAmount > 0 ? formatAmount(totalByRegion.integrationAmount) : '0'}</td>
                                                </tr>
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">No data available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
        </div>

    );
};



export default DealSummary;
